// Hooks
import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';
import { useFeatures, getEnabledFeatures } from '../../hooks/features';
import { getClient } from '../../utils/getClient';

const MUTATION_PREFIX = ['RedVelvetApi', 'AmbassadorAnnualConfirmation'];

export function useAmbassadorAnnualConfirmation() {
  const features = useFeatures();
  const [searchParams] = useSearchParams();
  const client = getClient(getEnabledFeatures(features, searchParams));

  return useQuery({
    enabled: true,
    queryKey: MUTATION_PREFIX,
    queryFn: async () => {
      const response = await client.ambassadorAnnualConfirmationVerification();
      return response.isSuccess;
    },
  });
}
